import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './dossier-workflow.action';
import { DossierWorkflow } from './dossier-workflow.model';

@Injectable({ providedIn: 'root' })
export class DossierWorkflowTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                step_status: null,
                type_text: '',
                trigger_at: '',
                sent_on: ''
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'trigger_at';
    initialSortDirection = 'asc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    dossierId: string = "";
    workflow: DossierWorkflow;
    statuses = [
        {"id": "1", "name": "WORKFLOW.status-pending"},
        {"id": "2", "name": "WORKFLOW.status-completed"},
        {"id": "3", "name": "WORKFLOW.status-skipped"}
    ];

    columns = [
                { prop: 'trigger_at', name: 'WORKFLOW.trigger-datetime', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'sent_on', name: 'WORKFLOW.sent-on', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'type_text', name: 'WORKFLOW.step', sortable: false, hasFilter: false, filter: "input", widthSet: 600},
                { prop: 'step_status', name: 'WORKFLOW.sttaus', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({dossierId: this.dossierId}));
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            step_status: null,
            type_text: '',
            trigger_at: '',
            sent_on: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}